<div class="vertical-filters" [ngClass]="{ collapsed: !isFiltersMenuOpen }">
  <div class="vertical-filters-header">
    <img src="assets/images/common/filter.svg" (click)="onToggleClick()" alt="filter" />
    <div>Filters</div>
    <img
      src="assets/images/arrows/chevron.svg"
      class="vertical-filters-header-img"
      (click)="onToggleClick()"
      alt="toggle"
    />
  </div>
  <div class="vertical-filters-options">
    <div class="vertical-filters-options-container">
      @for (optionGroup of optionsInsideCategories$ | async; track optionGroup.displayName) {
        @if (optionGroup.displayName) {
          <app-accordion
            [inMultiSelect]="true"
            [expanded]="expandedCategories[optionGroup.displayName]"
            [accordionTitle]="optionGroup.displayName | beautifyDisplayString"
            (accordionExpansionEvent)="expandClicked(optionGroup.displayName, $event)"
          >
            @for (option of optionGroup.options; track option.id) {
              <div
                class="vertical-filters-option"
                [ngClass]="{
                  'vertical-filters-option-selected': selectedIds.has(option.id) && !option.disabled,
                  'vertical-filters-option-disabled': option.disabled,
                }"
                (click)="onSelect(option.id)"
              >
                <mat-checkbox
                  color="primary"
                  [checked]="selectedIds.has(option.id)"
                  (click)="$event.stopPropagation()"
                  (change)="onSelect(option.id)"
                >
                </mat-checkbox>
                @if (option.iconPath) {
                  <img [src]="option.iconPath" class="option-img" />
                }
                @if (!option.disabled) {
                  <div class="vertical-filters-option-text">
                    {{
                      option.withoutBeautifyDisplayName
                        ? option.displayName
                        : (option.displayName | beautifyDisplayString)
                    }}
                  </div>
                }
              </div>
            }
          </app-accordion>
        }
      }
      <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Actor">
        <app-autocomplete-api
          [searchValuesCtrl]="searchActorValuesCtrl"
          [pageFilters]="pageFilters"
          [filteredValues]="filteredActorValues"
          [isLoading$]="isActorLoading$"
          [filterType]="actorFilterEnum"
          (optionOnSelection)="actorSubmitted($event)"
        >
        </app-autocomplete-api>
      </app-accordion>
      <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Agent">
        <app-autocomplete-api
          [searchValuesCtrl]="searchAgentValuesCtrl"
          [pageFilters]="pageFilters"
          [filteredValues]="filteredAgentValues"
          [isLoading$]="isAgentLoading$"
          [filterType]="agentNameFilterEnum"
          (optionOnSelection)="agentSubmitted($event)"
        >
        </app-autocomplete-api>
      </app-accordion>
    </div>
  </div>
</div>
<div [ngClass]="{ collapsed: isFiltersMenuOpen }">
  <img
    src="assets/images/arrows/filters-menu-closed.svg"
    (click)="onToggleClick()"
    class="collapsed-img"
    alt="collapse"
  />
</div>
